// extracted by mini-css-extract-plugin
module.exports = {"input":"ProfileStatus_input__3rTf9","statusText":"ProfileStatus_statusText__3GF3M"};